import { validateTrackTimeRange } from '@/views/vehicle-monitor/vehicleMonitoringSession'
/**
 * 运输规划筛选：车牌、出发时间区间（与 LeftJoin / TransportService 共用）
 */

/** 出发时间区间最大跨度：3 天（与原先「不超过 72 小时」一致：3×24h） */
export const SEARCH_TIME_RANGE_MAX_MS = 3 * 24 * 60 * 60 * 1000

/** 允许查询的最早自然日：当前日 0 点往前 180 天 */
export function getSearchEarliestAllowedDate() {
  const d = new Date()
  const day = d.getDate()
  d.setDate(1)
  d.setMonth(d.getMonth() - 6)
  const end = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate()
  d.setDate(Math.min(day, end))
  return d
}

/**
 * 车牌格式：省份简称 1 + 字母 1 + 5 位或 6 位字母数字
 */
export function isLicensePlateFormatValid(vehicleNo) {
  if (vehicleNo == null || typeof vehicleNo !== 'string') return false
  const v = vehicleNo.trim()
  if (!v) return false
  const re7 =
    /^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新使]{1}[A-Z]{1}[0-9a-zA-Z]{5}$/
  const re8 =
    /^[京津冀晋蒙辽吉黑沪苏浙皖闽赣鲁豫鄂湘粤桂琼川贵云渝藏陕甘青宁新使]{1}[A-Z]{1}[0-9a-zA-Z]{6}$/
  return re7.test(v) || re8.test(v)
}

/**
 * 识别 vnos 风格「车牌_颜色码」输入：若「_」前一段为合法车牌、后缀为纯数字，则拆成纯车牌 + 颜色；
 * 否则整串视为车牌，颜色用 fallbackVco（空则默认 '2'）。
 * @param {string|null|undefined} plateStr
 * @param {string|null|undefined} fallbackVco
 * @returns {{ plate: string, vco: string }}
 */
export function splitPlateAndVcoFromCombinedInput(plateStr, fallbackVco) {
  const fb =
    fallbackVco != null && String(fallbackVco).trim() !== '' ? String(fallbackVco).trim() : '2'
  const s = plateStr != null ? String(plateStr).trim() : ''
  if (!s) return { plate: '', vco: fb }
  const last = s.lastIndexOf('_')
  if (last <= 0) return { plate: s, vco: fb }
  const head = s.slice(0, last).trim()
  const tail = s.slice(last + 1).trim()
  if (/^\d+$/.test(tail) && isLicensePlateFormatValid(head)) {
    return { plate: head, vco: tail }
  }
  return { plate: s, vco: fb }
}

/**
 * @param {string|Date} startTime
 * @param {string|Date} endTime
 * @returns {{ valid: boolean, message?: string }}
 */
export function validateSearchTimeRange(startTime, endTime) {
  if (!startTime || !endTime) {
    return { valid: false, message: '请选择出发时间' }
  }
  const parse = value => value instanceof Date ? value.getTime() : Date.parse(String(value).replace(' ', 'T') + '+08:00')
  try { validateTrackTimeRange(parse(startTime), parse(endTime)); return { valid: true } }
  catch (error) { return { valid: false, message: error.message } }
}
